module.exports = __webpack_public_path__ + "media/images/pic/labels/c2_2-226cc2fb7a823e99d1f4237923ef4d90.png";